import * as React from "react"
import { Dialog as SheetPrimitive } from "radix-ui"
import { XIcon } from "lucide-react"
import { cn } from "src/utils/cn"

function Sheet({ ...props }) {
  return <SheetPrimitive.Root data-slot="sheet" {...props} />
}

function SheetTrigger({ ...props }) {
  return <SheetPrimitive.Trigger data-slot="sheet-trigger" {...props} />
}

function SheetClose({ ...props }) {
  return <SheetPrimitive.Close data-slot="sheet-close" {...props} />
}

function SheetPortal({ ...props }) {
  return <SheetPrimitive.Portal data-slot="sheet-portal" {...props} />
}

function SheetOverlay({ className, ...props }) {
  return (
    <SheetPrimitive.Overlay
      data-slot="sheet-overlay"
      className={cn(
        "fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        className
      )}
      {...props}
    />
  )
}

function SheetContent({ side = "right", className, children, ...props }) {
  return (
    <SheetPortal>
      <SheetOverlay />
      <SheetPrimitive.Content
        data-slot="sheet-content"
        className={cn(
          "fixed z-50 bg-white shadow-2xl transition-transform duration-300 ease-in-out",
          side === "right" && "top-0 bottom-0 right-0 w-[90%] sm:max-w-[480px] border-l border-slate-200",
          side === "left"  && "top-0 bottom-0 left-0 w-[90%] sm:max-w-[480px] border-r border-slate-200",
          side === "top"   && "top-0 left-0 right-0 border-b border-slate-200",
          side === "bottom"&& "bottom-0 left-0 right-0 border-t border-slate-200",
          className
        )}
        {...props}
      >
        {children}
        <SheetPrimitive.Close className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 disabled:pointer-events-none">
          <XIcon className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </SheetPrimitive.Close>
      </SheetPrimitive.Content>
    </SheetPortal>
  )
}

function SheetHeader({ className, ...props }) {
  return (
    <div className={cn("flex flex-col space-y-1.5 px-6 pt-6 pb-4 border-b border-slate-100", className)} {...props} />
  )
}

function SheetFooter({ className, ...props }) {
  return (
    <div className={cn("flex flex-row justify-end gap-2 px-6 py-4 border-t border-slate-100 bg-slate-50", className)} {...props} />
  )
}

function SheetTitle({ className, ...props }) {
  return (
    <SheetPrimitive.Title className={cn("text-base font-semibold text-slate-900", className)} {...props} />
  )
}

function SheetDescription({ className, ...props }) {
  return (
    <SheetPrimitive.Description className={cn("text-sm text-slate-500", className)} {...props} />
  )
}

export { Sheet, SheetPortal, SheetOverlay, SheetTrigger, SheetClose, SheetContent, SheetHeader, SheetFooter, SheetTitle, SheetDescription }
